import httpService from '@/app/arch/services/HttpService';

export default class UsersPinRequest {
  static baseUrl() {
    return '/account/users/';
  }

  static get(userSystemId) {
    return httpService.get(
      `${this.baseUrl()}check-user-status/${userSystemId}`,
    );
  }

  static unlock(userSystemId, clientId) {
    return httpService.patch(
      `${this.baseUrl()}pin/unlock-by-user/${userSystemId}/${clientId}`,
    );
  }
}
